import { render, staticRenderFns } from "./HabladoresHoyComponent.vue?vue&type=template&id=4843beac&"
import script from "./HabladoresHoyComponent.vue?vue&type=script&lang=js&"
export * from "./HabladoresHoyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports